var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,style:({'background-color': _vm.component_background})},[(_vm.$slots.default)?_vm._t("default"):_c('span',{style:({'color': _vm.component_color})},[_vm._v(_vm._s(_vm._f("InitialsFilter")(_vm.name ?? 'A Aa')))]),(_vm.loading)?_c('Loading',{staticClass:"small",attrs:{"fill":true}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }